import { makeAutoObservable } from 'mobx';
import { ChangeEventNameT } from 'types/frontend/ChangeEvent';

export default class ChangeEventStore {
  eventNameAndTimestampMap = new Map<ChangeEventNameT, string>();

  constructor() {
    makeAutoObservable(this);
  }

  emit = (eventName: ChangeEventNameT) => {
    this.eventNameAndTimestampMap.set(eventName, new Date().toString());
  };
}
